import { Injectable } from '@angular/core';
import { User, UserManager, UserManagerSettings } from 'oidc-client';
import { Subject } from 'rxjs';
import { CurrentUser } from '../models/current-user';
import { Constants } from '../utilities/constants';
import { Parameters } from '../utilities/parameters';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private idpSettings: UserManagerSettings = {
    authority: Constants.authRoot,
    client_id: Constants.clientId,
    redirect_uri: `${Constants.authRoot}/#/signin-callback`,
    scope: "openid profile email role IdentityServerApi offline_access",
    response_type: "code",
    post_logout_redirect_uri: `${Constants.authRoot}/#/signout-callback`,
    filterProtocolClaims: true,
    metadata: {
      issuer: Constants.authRoot,
      authorization_endpoint: `${Constants.authRoot}/connect/authorize`,
      token_endpoint: `${Constants.authRoot}/connect/token`,
      end_session_endpoint: `${Constants.authRoot}/connect/endsession`,
      revocation_endpoint: `${Constants.authRoot}/connect/revocation`,
      userinfo_endpoint: `${Constants.authRoot}/connect/userinfo`
    },
    loadUserInfo: true,
    accessTokenExpiringNotificationTime: 15
  }

  private user: User | null = null;
  private userLoginSubject = new Subject<boolean>();
  private userManager: UserManager;

  public loginChanged = this.userLoginSubject.asObservable();

  constructor(private apiService: ApiService) {
    this.userManager = new UserManager(this.idpSettings);
    this.userManager.events.addAccessTokenExpiring(() => {
      this.userManager.signinSilent();
    })
    this.userManager.events.addUserLoaded(u => {
      this.user = u
    })
  }

  public finishLogin = (): Promise<User> => {
    return this.userManager.signinRedirectCallback().then(user => {
      this.user = user;
      let isValid: boolean = this.checkUser(user);
      if (isValid) {
        this.apiService.getCurrentUser().subscribe((loggedUser: CurrentUser) => {
          Parameters.loggedUser = loggedUser;
        });
        this.apiService.getEnums().subscribe(r => {
          Parameters.roles = r[0];
          Parameters.receivers = r[1];
        });
      }
      this.userLoginSubject.next(isValid);
      return user;
    })
  }

  public finishLogout = () => {
    this.user = null;
    this.userLoginSubject.next(false);
    return this.userManager.signoutRedirectCallback();
  }

  public getAccessToken(): string {
    return !!this.user && !this.user.expired ? this.user.access_token : '' 
  }

  public isAuthenticated(): boolean {
    if (!!this.user && !this.user.expired)
      return this.checkUser(this.user)
    else
      return false;
  }

  public login = () => {
    return this.userManager.signinRedirect();
  }

  public logout = () => {
    return this.userManager.signoutRedirect();
  }

  private checkUser = (user: User | null): boolean => {
    return !!user && !user.expired;
  }
}
